import fetch from '../utils/fetch'


/******环境变量配置接口**********/

// 根据参数获取环境变量列表
export function getEnvconfigList (query) {
  return fetch({
    url: '/envconfig/getEnvList',
    method: 'get',
    params: query
  })
}

// 根据id获取环境变量详情
export function getEnv (env_id) {
  return fetch({
    url: '/envconfig/getEnv' + env_id,
    method: 'get',
  })
}

// 创建环境变量
export function createEnv (query) {
  return fetch({
    url: '/envconfig/createEnv',
    method: 'post',
    params: query
  })
}

// 更新环境变量
export function updateEnv (query) {
  return fetch({
    url: '/envconfig/editEnv',
    method: 'put',
    params: query
  })
}

// 删除环境变量
export function deleteEnv (env_id) {
  return fetch({
    url: '/envconfig/delEnv/' + env_id,
    method: 'delete',
  })
}




// WEBPACK FOOTER //
// ./src/api/envconfigs.js